<template>
  <div class="life_costs-pages-login" id="life_costs-pages-login">
    <div class="login-container">
      <div class="login-dmall-os-png"></div>
      <div class="login-pic-new"></div>
      <div class="login-content" style="height: 400px;">
        <div class="login-headbox">
          <div class="login-des">登录</div>
          <!-- <div class="login-login-des"></div> -->
        </div>
        <a-form class="login-box" :form="form" @submit="submit">
          <a-tabs :default-active-key="loginType" @change="callback">

            <a-tab-pane tab="手机验证码登录" key="1">
              <a-form-item>
                <a-input v-decorator="[
                  'userName',
                  {
                    rules: [{ required: loginType === '1', message: '请输入手机号！' }],
                    initialValue: submitData.userName
                  }
                ]" placeholder="手机号">
                  <a-icon slot="prefix" type="mobile" style="color: rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-row :gutter="8">
                  <a-col :span="14">
                    <a-input v-decorator="[
                      'verificationCode',
                      {
                        rules: [{ required: loginType === '1', message: '请输入验证码！' }],
                        initialValue: submitData.verificationCode
                      }
                    ]" placeholder="验证码">
                      <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,.25)" />
                    </a-input>
                  </a-col>
                  <a-col :span="10">
                    <a-button style="width:100%;" @click.stop="getShortMessageEvt" :disabled="passwordText !== '获取验证码'"
                      :loading="messageLoading">{{passwordText}}</a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-tab-pane>
            <a-tab-pane tab="密码登录" key="2" forceRender>
              <a-form-item>
                <a-input v-decorator="[
                  'userName2',
                  {
                    rules: [{ required: loginType === '2', message: '请输入手机号！' }],
                    initialValue: submitData.userName2
                  }
                ]" placeholder="手机号">
                  <a-icon slot="prefix" type="mobile" style="color: rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input v-decorator="[
                  'password',
                  {
                    rules: [{ required: loginType === '2', message: '请输入密码!' }],
                    initialValue: submitData.password
                  }
                ]" type="password" placeholder="密码">
                  <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
            </a-tab-pane>
          </a-tabs>
          <a-form-item>
            <div hidden>
              <button id="TencentCaptcha" data-appid="2066691790" data-cbfn="captchaCallback" type="button">验证</button>
            </div>
            <a-button :disabled="hasErrors(form.getFieldsError())" block type="primary" html-type="submit"
              :loading="loginLoading" class="login-form-button">登录</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="login-footer">
        <p class="content-des" style="bottom: 5px;">
          <a href="http://www.wumart.com/index.php/5383eeff0a?city=bj">合作途径</a> | <a
            href="http://www.wumart.com/index.php/5371d23e0a?city=bj">客户服务</a> | <a
            href="http://www.wumart.com/index.php/5383fd600a?city=bj">走进物美</a>
        </p>
        <p class="date-life" style="bottom: 5px;">物美集团 版权所有 京ICP备10026962号</p>
        <p>总部地址:北京市海淀区西四环北路158-1号 物美商业大厦</p>
      </div>
    </div>

    <div id="webgl-canvas">
      <canvas></canvas>
    </div>
  </div>
</template>

<script>
// import logincanvas from '../lib/plugins/logincanvas'
import ajax from '../lib/axios/ajax'
import { loginGetShortMessage, loginDoLogin } from '../lib/axios/apilist'

export default {
  name: 'login',
  components: {
  },
  data() {
    // 请求地址
    let ajaxParam = {
      loginGetShortMessage: loginGetShortMessage,
      loginDoLogin: loginDoLogin,
    };
    let submitData = {
      userName: undefined,
      userName2: undefined,
      password: undefined,
      verificationCode: undefined,
    }
    let hasErrors = (fieldsError) => {
    return Object.keys(fieldsError).some(function(field){fieldsError[field]});
    }
    return {
      timer: null,
      common: {
        codeUrl: ''
      },
      ajaxParam,
      submitData,
      messageLoading: false,
      loginLoading: false,
      loginType: '1',
      passwordText: '获取验证码',
      hasErrors,
      form: this.$form.createForm(this),
    }

  },
  mounted() {
  //进入页面
  //cabinVue 里面所有的this 都指向当前这个vue 实例
  //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function(){
      // nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用
    });

    // logincanvas.init("life_costs-pages-login")
    this.initCreateElement()
    //腾讯验证码回调
    window.captchaCallback = (res) => {
      
      this.loginEvt(res)
    }
  },
  beforeCreate () {
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy:function () {
    
  },
  destroyed: function () {
    //离开页面方法
  },
  //监听属性变化，，变量必须是data里声明的
  watch:{},
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {
  },
  methods: {
    initCreateElement(){
      var tcaptcha = document.getElementById('tcaptcha')
      
      if(tcaptcha === null){
        var tlScript = document.createElement('script');
        tlScript.id = 'tcaptcha'
        var head = document.getElementsByTagName('head')[0];
        tlScript.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
        head.appendChild(tlScript);
      } else {
        location.reload()
      }
    },
    submit(e) {
      
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.submitData = {
            ...values
          }
          $("#TencentCaptcha").click();
        }
      });
    },
    loginEvt(captcha){
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      if(captcha.ret === 0){
        //此时就是滑块验证码验证成功，这里请求登录后台接口，并传参新增captchaTicket（值为res.ticket）和captchaRandstr(值为res.randstr)
        this.loginLoading = true
        //搜索地址
        let url = this.ajaxParam.loginDoLogin;
        let successFunc = (res) => {
          setTimeout(() => {
            this.loginLoading = false
          }, 500);
          if (res.code === "0000") {
            this.$router.push({
              path: "/pay/unpaidList",
            });
          } else {
            this.$error({
              title: '提示',
              content: res.result,
            });
          }
        };
        let errorFunc = (res) =>{
          this.loginLoading = false
          this.$error({
          title: '提示',
          content: res.result,
        });
        };
        let values = this.loginType === '1' ? {
          userName: this.submitData.userName,
          verificationCode: this.submitData.verificationCode
        } : {
          userName: this.submitData.userName2,
          password: this.submitData.password
        }
        let requestParam = {
          ...values,
          loginType: this.loginType,
          codeKey: '',
          codeValue: '',
          captchaTicket: captcha.ticket,
          captchaRandstr: captcha.randstr
        }
        var href = window.location.href
        var index = href.indexOf('returnUrl=');
        if (index != -1) {
          var returnUrl = href.split('returnUrl=');
          requestParam.returnUrl = returnUrl[1];
        }
        //fetch ajax提交数据
        ajax.fetch(url, requestParam, successFunc,errorFunc)
      }
    },
    captchaCode () {
      // var date = new Date();
      // this.submitData.codeKey = date.getTime() + Math.random();
      // this.common.codeUrl = cgiMain.captchaCode + '?key=' + this.submitData.codeKey;
    },
    resetEvt() {
      this.form.resetFields();
      this.submitData = {
        userName: undefined,
        password: undefined,
      }
    },
    callback (key) {
      this.loginType = key
      this.resetEvt()
    },
    getShortMessageEvt(){
      this.messageLoading = true
      //搜索地址
      let url = this.ajaxParam.loginGetShortMessage;
      let successFunc = (res) => {
        if (res.code === "0000") {
          let index = 60
          var timer = setInterval(() => {
            if(index === 0){
              clearInterval(timer)
              this.passwordText = '获取验证码'
            }else{
              this.passwordText = `${index}s后重新获取`
              index--
            }
          }, 1000);
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) =>{
        this.messageLoading = false
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        userName: this.form.getFieldsValue().userName
      }
      
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc,errorFunc)
    }
  }

}
</script>

<style scoped>
.life_costs-pages-login {
	background: #5362bc url(../../public/images/bgnew.png) no-repeat center left;
	width: 100vw;
	height: 100vh;
	position: relative;
	backgrouna-size: cover;
}
.life_costs-pages-login .login-dmall-os-png {
    width: 100%;
    height: 100%;
    top: 3.75%;
    left: 2.08%;
    position: absolute;
    background: url(../../public/images/logo.png) no-repeat top left;
    backgrouna-size: 150px;
}
.life_costs-pages-login .login-pic-new {
    width: 100%;
    height: 100%;
    top: 11.75%;
    left: 13.08%;
    position: absolute;
    /* background: url(../../public/images/picnew.png) no-repeat top left; */
}
.life_costs-pages-login .login-box #passwordShow{
    width: 24px;
    height: 24px;
    top: 54%;
    right: 13%;
    position: absolute;
    /* background: url(../../public/images/passWordnew.png) no-repeat top left; */
}
.life_costs-pages-login .login-footer {
    width: 100%;
    height: 100%;
    top: 90.13%;
    left: 0;
    position: absolute;
    color: rgba(255,255,255,1);
    text-align: center;
}
.life_costs-pages-login .content-des {
	color: rgba(255,255,255,1);
}
.life_costs-pages-login .content-des a {
	color: rgba(255,255,255,1);
}
.life_costs-pages-login .login-des {
    height: 56px;
    color: #333333;
    font-size: 35px;
}
.life_costs-pages-login .login-login-des {
    width: 125px;
    height: 48px;
    color: #333333;
    font-size: 30px;
}

.life_costs-pages-login .login-box{
    /* margin-top: 30px; */
}

.life_costs-pages-login .company-info {
	font-size: 12px;
	color: #999999;
	position: absolute;
	bottom: 40px;
	right: 40px;
}

.life_costs-pages-login .J_login_submit{
    color: #fff;
    backgrouna-color: #11C896;
}

.life_costs-pages-login .login-content {
    width: 360px;
    height: 460px;
    padding: 40px;
    box-sizing: border-box;
    position: absolute;
    top: 17%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
}
@media screen and (max-width: 375px){
    .life_costs-pages-login .login-content {
        left: 50%;
        margin-left: -150px;
        width: 300px;
    }
}

@media screen and (min-width: 375px){
    .life_costs-pages-login .login-content {
        left: 50%;
        margin-left: -180px;
    }
}
@media screen and (min-width:1200px){
    .life_costs-pages-login .login-content {
        left: 74%;
    }
}

</style>